import type { Observable } from "rxjs";
import { timer as observableTimer, zip as observableZip } from "rxjs";

export const zipWithTimer =
    <T>(minimumDelay: number | Date = 1000) =>
    (observable: Observable<T>) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        return observableZip(observable, observableTimer(minimumDelay, 0), (t, timerValue) => t);
    };
